export default{
  bind(el, binding) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header'),
      dragDom = el.querySelector('.el-dialog')

    dialogHeaderEl.style.cssText += ';cursor:move;'

    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const getStyle = (function() {
      if (window.document.currentStyle) {
        return (dom, attr) => dom.currentStyle[attr]
      } else {
        return (dom, attr) => getComputedStyle(dom, false)[attr]
      }
    })()

    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop

      const dragDomWidth = dragDom.offsetWidth
      const dragDomheight = dragDom.offsetHeight

      const screenWidth = document.body.clientWidth
      const screenHeight = document.body.clientHeight

      const minDragDomLeft = dragDom.offsetLeft - dragDomWidth / 2
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth / 2

      const minDragDomTop = dragDom.offsetTop - dragDomheight / 2
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight / 2

      // 获取到的值带px 正则匹配替换
      let styL = getStyle(dragDom, 'left')
      let styT = getStyle(dragDom, 'top')

      if (styL.includes('%')) {
        styL = +document.body.clientWidth * (+styL.replace(/%/g, '') / 100)
        styT = +document.body.clientHeight * (+styT.replace(/%/g, '') / 100)
      } else {
        styL = +styL.replace(/\px/g, '')
        styT = +styT.replace(/\px/g, '')
      }

      document.onmousemove = function(e) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-(top) > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }

        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
      }

      document.onmouseup = function() {
        document.onmousemove = null
        document.onmouseup = null
      }
    }

    // 添加拖拽手柄
    const addResizeHandle = (position, cursor, style) => {
      const handle = document.createElement('div')
      handle.style.cssText = `position: absolute; cursor: ${cursor}; z-index: 9999; ${style}`
      handle.style.backgroundColor = 'transparent'
      dragDom.appendChild(handle)

      handle.onmousedown = (e) => {
        e.stopPropagation()
        const startX = e.clientX
        const startY = e.clientY
        const startWidth = dragDom.offsetWidth
        const startHeight = dragDom.offsetHeight

        document.onmousemove = function(e) {
          // 获取配置的最小尺寸
          const minWidth = binding.value?.minWidth || 100
          const minHeight = binding.value?.minHeight || 100
          const maxWidth = binding.value?.maxWidth || Infinity
          const maxHeight = binding.value?.maxHeight || Infinity

          if (position.includes('right')) {
            const newWidth = Math.min(
              maxWidth,
              Math.max(minWidth, startWidth + (e.clientX - startX))
            )
            dragDom.style.width = `${newWidth}px`
          }

          if (position.includes('bottom')) {
            const newHeight = Math.min(
              maxHeight,
              Math.max(minHeight, startHeight + (e.clientY - startY))
            )
            dragDom.style.height = `${newHeight}px`
          }
        }

        document.onmouseup = function() {
          document.onmousemove = null
          document.onmouseup = null
        }
        return false
      }
    }

    // 添加拉伸区域
    addResizeHandle('right', 'e-resize', 'width: 6px; height: 100%; right: 0; top: 0;')
    addResizeHandle('bottom', 's-resize', 'width: 100%; height: 6px; left: 0; bottom: 0;')
    addResizeHandle('bottom-right', 'se-resize', 'width: 10px; height: 10px; right: 0; bottom: 0;')
  }
}
